import React from 'react';
import { Layout } from 'antd';
import Header from '../shared/Header';
import ServiceableUrls from '../serviceableUrls/ServiceableUrls';
import ServiceableUrlsPercentBar from '../serviceableUrls/ServiceableUrlsPercentBar';
import useUrlState from '../../hooks/useUrlState';
import DomainSetupCheck from '../websiteIndexEntry/DomainSetupCheck';
import WebsiteIndexEntrySelector from '../websiteIndexEntry/WebsiteIndexEntrySelector';

const { Content } = Layout;

export default function ServiceableUrlsPage() {
    const [urlState] = useUrlState();
    const { w_guid: websiteGuid } = urlState;

    return (
        <Content className="general-layout-content">
            <Header
                title={<WebsiteIndexEntrySelector />}
                showRedirectArrow
                leftSideExtra={<ServiceableUrlsPercentBar selectedWebsiteGuid={websiteGuid} />}
            />
            <DomainSetupCheck
                key={websiteGuid}
                websiteGuid={websiteGuid}
            >
                <ServiceableUrls websiteGuid={websiteGuid!} />
            </DomainSetupCheck>
        </Content>
    );
}
